module.exports = __webpack_public_path__ + "img/02.29d754f0.png";